export default function button({
  title,
  color,
  backgroundColor,
  onClick,
  submitting,
  active,
}) {
  return (
    <div className="flex w-full">
      <button
        type="submit"
        className="flex px-4 py-3 justify-center rounded-md w-full"
        style={{
          backgroundColor: backgroundColor,
          color: color,
          opacity: submitting || !active ? 0.25 : 1,
        }}
        onClick={onClick}
        disabled={submitting || !active}
      >
        <span
          className="text-lg"
          style={{ fontWeight: 700, fontStyle: "normal" }}
        >
          {title}
        </span>
      </button>
    </div>
  );
}
